import { Environments } from "./config";

export default Environments[process.env.APP_CONFIG_ENV ?? "local"];
